export default __webpack_public_path__ + "static/pota2x-1e3310e8db3152ad445a89c2bce68184.png";